"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorsKeys = exports.getColor = void 0;
var COLORS = {
    // Primary
    PURPLE_100: '#6B65E7',
    LIGHT_PURPLE_50: '#BAB7F4',
    DARK_PURPLE_100: '#625FA6',
    // Semantic
    GREEN_100: '#A1CCCF',
    GREEN_30: '#DBECED',
    YELLOW_100: '#FCC787',
    YELLOW_30: '#FEEEDB',
    VELVET_100: '#C39DFF',
    VELVET_30: '#EDE2FF',
    SALMON_100: '#FF8C78',
    SALMON_30: '#FFDDD7',
    PINK_100: '#F5BAC4',
    PINK_30: '#FCEAED',
    BLUE_100: '#3399FF',
    BLUE_30: '#C2E0FF',
    GRASS_100: '#9FCE8F',
    GRASS_30: '#E2F0DD',
    // Neutrals
    WHITE_100: '#FFFFFF',
    YELLOW_BG: '#FFFAF1',
    GRAY_BG: '#F0F0F2',
    PURPLE_DISABLED: '#CCCAF0',
    PURPLE_CLICK: '#7671D7',
    BLACK_100: '#000000',
    BLACK_80: '#333333',
    BLACK_60: '#666666',
    BLACK_40: '#999999',
    BLACK_20: '#CCCCCC',
    BLACK_10: '#E6E6E6',
    // System
    // need to update to SYSTEM_RED_100
    RED_100: '#EF5350',
    SYSTEM_ORANGE: '#FF981D',
    SYSTEM_GREEN: '#3BB741',
    // Skin
    SKIN_TONE_1: '#FFEDDE',
    SKIN_TONE_2: '#E8BCA3',
    SKIN_TONE_3: '#9B663D',
    SKIN_TONE_4: '#544535',
    // new grey scale
    WHITE: '#FFFFFF',
    GREY_5: '#fafafa',
    GREY_10: '#f5f5f5',
    GREY_20: '#e5e5e5',
    GREY_30: '#d4d4d4',
    GREY_40: '#a3a3a3',
    GREY_50: '#737373',
    GREY_60: '#525252',
    GREY_70: '#404040',
    GREY_80: '#262626',
    GREY_90: '#171717',
    BLACK: '#000000',
};
var getColor = function (color) { return COLORS[color]; };
exports.getColor = getColor;
// only for storybook
exports.colorsKeys = Object.keys(COLORS);
